import ClevertapReact from 'src/utils/clever-tap'

const callCleverTapEvent = (event = '', payload = null) => {
    ClevertapReact.event(event, payload)
}

export default callCleverTapEvent;